import Navbar from '../components/navbar/Navbar';
import { Route, Routes } from 'react-router-dom';
import Usuarios from '../usuarios/Usuarios';
import Productos from '../productos/productos';
import Pedidos from '../pedido/Pedidos';
import Cuentas from '../cuentas/Cuentas';
import Reportes from '../reportes/reportes';
import Pantallas from '../pantallas/Pantallas';
import Boundary from '../error/Boundary'
import { ProtectedRoute } from '../components/ProtectedRoute';
import Politicas from '../politicas/politicas';
function Main() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      width: '100vw',
      justifyItems: 'center',
      padding: 0,
      margin: 0
    }}>
      <Navbar />
      <Boundary>
        <Routes>
          <Route exact path='/politicas' element={<Politicas />} />
          <Route exact path='/usuarios' element={<ProtectedRoute><Usuarios /></ProtectedRoute>} />
          <Route exact path='/productos' element={<ProtectedRoute><Productos /></ProtectedRoute>} />
          <Route exact path='/pedidos' element={<ProtectedRoute><Pedidos /></ProtectedRoute>} />
          <Route exact path='/cuentas' element={<ProtectedRoute><Cuentas /></ProtectedRoute>} />
          <Route exact path='/reportes' element={<ProtectedRoute><Reportes /></ProtectedRoute>} />
          <Route exact path='/' element={<Pantallas />} />
        </Routes>
      </Boundary>
    </div>
  );
}

export default Main;
